var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2500_2297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0177 16.356H31.5052C30.9588 16.356 30.4391 16.6176 30.1177 17.0662L21.6963 28.7068L17.882 23.4312C17.5606 22.988 17.0463 22.721 16.4945 22.721H13.982C13.6338 22.721 13.4302 23.1161 13.6338 23.3991L20.3088 32.6262C20.4665 32.8456 20.6743 33.0243 20.9152 33.1476C21.156 33.271 21.4228 33.3353 21.6936 33.3353C21.9643 33.3353 22.2312 33.271 22.472 33.1476C22.7129 33.0243 22.9207 32.8456 23.0784 32.6262L34.3606 17.0341C34.5695 16.7511 34.3659 16.356 34.0177 16.356Z",
    fill: "#006353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0.925781C10.7464 0.925781 0 11.6373 0 24.8479C0 38.0584 10.7464 48.7699 24 48.7699C37.2536 48.7699 48 38.0584 48 24.8479C48 11.6373 37.2536 0.925781 24 0.925781ZM24 44.7117C12.9964 44.7117 4.07143 35.8157 4.07143 24.8479C4.07143 13.88 12.9964 4.98399 24 4.98399C35.0036 4.98399 43.9286 13.88 43.9286 24.8479C43.9286 35.8157 35.0036 44.7117 24 44.7117Z",
    fill: "#006353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2500_2297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 47.8441,
    fill: "white",
    transform: "translate(0 0.925781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.df15d524c6b4c58bc4187dbc71331008.svg";
export { ForwardRef as ReactComponent };